import React, { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Button,
  Drawer,
  TextField,
} from '@material-ui/core';
import { ArrowBack, ExpandLess, ExpandMore } from '@material-ui/icons';
import { GUEST_ROOM_EXPERIENCE_TEMPLATE } from '../../../../../../../constants/GuestRoomExperienceConst';
import './Template-View.scss';
import {
  curtainType,
  lightIcons,
  lightType,
} from '../../../../../../../constants/ConfigurationsConst';
import { getUser } from '../../../../../../../utils/PropertyAPIUtils';
import { notificationManager } from '../../../../../../../utils/NotificationUtils';
import { useDispatch, useSelector } from 'react-redux';
import GuestRoomExperienceTemplateCreate from '../template-create/Template-Create';
import { selectedHotelSelector } from '../../../../../../property/propertySlice';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../../../utils/loaderSlice';
import { ENVIRONMENT } from '../../../../../../../env/Configurations';

const DETAIL_TAB = 'detail_tab';
const LIGHT_TAB = 'light_tab';
const SCENE_TAB = 'scene_tab';
const THERMO_TAB = 'thermostat_tab';
const CURTAIN_TAB = 'curtain_tab';
const DOOR_LOCK_TAB = 'door_lock_tab';

const GuestRoomExperienceTemplateView = (props) => {
  const { template, onViewToggle, onBack } = props;
  const [activeTab, setActiveTab] = useState(DETAIL_TAB);
  const [expanded, setExpanded] = useState(false);
  const [createdBy, setCreatedBy] = useState({
    firstName: '',
    imageUrl: '',
  });
  const [drawerState, setDrawerState] = useState(false);
  const dispatch = useDispatch();

  const convertEnumToReadable = (arr, value) => {
    return arr.find((item) => item.id === value)?.name;
  };

  const getIconUrl = (icon) => {
    return lightIcons.find((item) => item.id === icon)?.url;
  };

  useEffect(() => {
    if (template?.createdBy) {
      dispatch(stepUpLoaderCount());
      getUser(template?.createdBy)
        .then((res) => {
          const obj = res.data.getUserById;
          setCreatedBy({
            firstName: obj.firstName,
            imageUrl: obj.imageUrl ?? '',
          });
        })
        .catch((error) => {
          if (ENVIRONMENT === 'dev') {
            console.log(error?.message);
          }

          notificationManager('danger', 'Unable to fetch user details');
        })
        .finally(() => {
          dispatch(stepDownLoaderCount());
        });
    }
  }, [template]);

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift'))
    ) {
      return;
    }
    setDrawerState(open);
  };

  return (
    <>
      <Drawer
        anchor={'right'}
        open={drawerState}
        onClose={toggleDrawer(false)}
        className='right-drawer'
      >
        <GuestRoomExperienceTemplateCreate
          toggleDrawer={(e) => setDrawerState(e)}
          template={template}
          hotelId={useSelector(selectedHotelSelector)}
          onDrawerToggle={(e) => setDrawerState(false)}
        />
      </Drawer>
      <div className='template-view'>
        <div className='mt-5 row mx-0'>
          <div className='col-md-6 px-0 d-flex align-items-center'>
            <Button
              variant='text'
              color='secondary'
              size='small'
              startIcon={<ArrowBack />}
              onClick={(e) => {
                onBack(GUEST_ROOM_EXPERIENCE_TEMPLATE);
                onViewToggle(false, null);
              }}
              className='me-2'
            >
              Back
            </Button>
            <span className='page-title'>{template?.name ?? 'Template'}</span>
          </div>
          <div className='col-md-6 d-flex justify-content-end my-2'>
            <Button
              variant='outlined'
              color='primary'
              onClick={(e) => setDrawerState(true)}
              size='small'
            >
              Edit
            </Button>
          </div>
        </div>
        <div className='card px-5 shadow mt-4 mx-3 mb-4 h-100'>
          <div className='mt-3 row'>
            <div className='d-flex flex-row justify-content-between align-items-center'>
              <div>
                <button
                  className={`template-view-tabitem ${activeTab === DETAIL_TAB && 'active-tab'}`}
                  onClick={(e) => setActiveTab(DETAIL_TAB)}
                >
                  Details
                </button>
                <button
                  className={`template-view-tabitem ${activeTab === LIGHT_TAB && 'active-tab'}`}
                  onClick={(e) => setActiveTab(LIGHT_TAB)}
                >
                  Lights
                </button>
                <button
                  className={`template-view-tabitem ${activeTab === SCENE_TAB && 'active-tab'}`}
                  onClick={(e) => setActiveTab(SCENE_TAB)}
                >
                  Scenes
                </button>
                <button
                  className={`template-view-tabitem ${activeTab === THERMO_TAB && 'active-tab'}`}
                  onClick={(e) => setActiveTab(THERMO_TAB)}
                >
                  Thermostat
                </button>
                <button
                  className={`template-view-tabitem ${activeTab === CURTAIN_TAB && 'active-tab'}`}
                  onClick={(e) => setActiveTab(CURTAIN_TAB)}
                >
                  Curtains
                </button>
                <button
                  className={`template-view-tabitem ${activeTab === DOOR_LOCK_TAB && 'active-tab'}`}
                  onClick={(e) => setActiveTab(DOOR_LOCK_TAB)}
                >
                  Door Lock
                </button>
              </div>
            </div>
            <div className='w-100 mt-4'>
              {activeTab === DETAIL_TAB && (
                <>
                  <div className='row mb-4'>
                    <div className='col-md-4'>
                      <p className='m-0 template-view-title'>Template Name</p>
                      <p className='m-0 template-view-content'>{template.name}</p>
                    </div>
                    <div className='col-md-8'>
                      <p className='m-0 template-view-title'>No of Rooms</p>
                      <p className='m-0 template-view-content'>{template.statistics.rooms}</p>
                    </div>
                  </div>
                  <div className='row mb-4'>
                    <div className='col-md-12'>
                      <p className='m-0 template-view-title'>No of Room Areas</p>
                      <p className='m-0 template-view-content'>{template?.areas?.length}</p>
                    </div>
                  </div>
                  <div className='row mb-4'>
                    <div className='col-md-12'>
                      <p className='m-0 template-view-title'>Room Areas</p>
                      {template?.areas.map((item) => (
                        <p key={item.id} className='m-0 template-view-content'>
                          {item.id} - {item.name}
                        </p>
                      ))}
                    </div>
                  </div>
                </>
              )}
              {activeTab === LIGHT_TAB && (
                <>
                  {template.lightsVendor.id !== '' && (
                    <>
                      <div className='row mb-4'>
                        <div className='col-md-12'>
                          <p className='m-0 template-view-title'>Vendor Name</p>
                          <p className='m-0 template-view-content'>{template.lightsVendor.name}</p>
                        </div>
                      </div>
                      {template?.lightsVendor?.attributes?.filter(
                        ({ key, value }, i) => value !== '',
                      ).length > 0 && (
                        <div className='row mb-4'>
                          <div className='d-flex vendor-card p-3 justify-content-between col-md-6'>
                            <div className='row w-100'>
                              {template.lightsVendor.attributes
                                .filter(({ key, value }, i) => value !== '')
                                .map(({ key, value }, i) => (
                                  <div
                                    className={`col-md-6 mb-3 ${
                                      i > 1 && !expanded ? 'hidden' : ''
                                    } `}
                                    key={i}
                                  >
                                    <TextField
                                      label={key}
                                      id={i + 'vendorAttr'}
                                      className='w-100'
                                      value={value}
                                      InputProps={{
                                        readOnly: true,
                                      }}
                                    />
                                  </div>
                                ))}
                            </div>
                            <div className='vendor-card-arrow '>
                              {expanded ? (
                                <ExpandLess fontSize='large' onClick={() => setExpanded(false)} />
                              ) : (
                                <ExpandMore fontSize='large' onClick={() => setExpanded(true)} />
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                  <div className='row mb-4'>
                    {template.areas.map((area, index) => {
                      return (
                        <Accordion className='mb-0 p-0'>
                          <AccordionSummary className='pl-0' expandIcon={<ExpandMore />}>
                            <p className='m-0 template-view-title'>
                              Room Area Name {index + 1} - {area.name}
                            </p>
                          </AccordionSummary>
                          {area.lights.map((item) => (
                            <AccordionDetails>
                              <div className='row vendor-card w-100 p-1'>
                                <div className='col-md-3'>
                                  <span>
                                    <img
                                      className='mx-2'
                                      height={'20px'}
                                      width={'20px'}
                                      src={getIconUrl(item?.icon)}
                                      alt={item?.name}
                                    />
                                  </span>
                                  <span color='secondary'>Light Name: </span>
                                  {item.name}
                                </div>
                                <div className='col-md-3'>
                                  <span color='secondary'>Light Type: </span>
                                  {convertEnumToReadable(lightType, item.type)}
                                </div>
                                <div className='col-md-6'>
                                  {item.type === 'DIMMER' && (
                                    <>
                                      <span color='secondary'>Dimmer Level: </span>
                                      {item?.dimmerLevel}
                                    </>
                                  )}
                                </div>
                              </div>
                            </AccordionDetails>
                          ))}
                        </Accordion>
                      );
                    })}
                  </div>
                </>
              )}
              {activeTab === SCENE_TAB && (
                <>
                  {template.scenesVendor.id !== '' && (
                    <>
                      <div className='row mb-4'>
                        <div className='col-md-12'>
                          <p className='m-0 template-view-title'>Vendor Name</p>
                          <p className='m-0 template-view-content'>{template.scenesVendor.name}</p>
                        </div>
                      </div>
                      {template.scenesVendor.attributes.filter(({ key, value }, i) => value !== '')
                        .length > 0 && (
                        <div className='row mb-4'>
                          <div className='d-flex vendor-card p-3 justify-content-between col-md-6'>
                            <div className='row w-100'>
                              {template.scenesVendor.attributes
                                .filter(({ key, value }, i) => value !== '')
                                .map(({ key, value }, i) => (
                                  <div
                                    className={`col-md-6 mb-3 ${
                                      i > 1 && !expanded ? 'hidden' : ''
                                    } `}
                                    key={i}
                                  >
                                    <TextField
                                      label={key}
                                      id={i + 'vendorAttr'}
                                      className='w-100'
                                      value={value}
                                      InputProps={{
                                        readOnly: true,
                                      }}
                                    />
                                  </div>
                                ))}
                            </div>
                            <div className='vendor-card-arrow '>
                              {expanded ? (
                                <ExpandLess fontSize='large' onClick={() => setExpanded(false)} />
                              ) : (
                                <ExpandMore fontSize='large' onClick={() => setExpanded(true)} />
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                  <div className='row mb-4'>
                    {template.areas.map((area, index) => {
                      return (
                        <Accordion className='mb-0 p-0'>
                          <AccordionSummary className='pl-0' expandIcon={<ExpandMore />}>
                            <p className='m-0 template-view-title'>
                              Room Area Name {index + 1} - {area.name}
                            </p>
                          </AccordionSummary>
                          {area.scenes.map((item) => (
                            <AccordionDetails>
                              <div className='row vendor-card w-100 p-3'>
                                <div className='col-md-3'>
                                  {/* Add Icon */}
                                  <span color='secondary'>Scene Name: </span>
                                  {item.name}
                                </div>
                                <div className='col-md-3'>
                                  <span color='secondary'>Light Type: </span>
                                  {convertEnumToReadable(lightType, item.type)}
                                </div>
                                <div className='col-md-6'>
                                  {item.type === 'DIMMER' && (
                                    <>
                                      <span color='secondary'>Dimmer Level: </span>
                                      {item?.dimmerLevel}
                                    </>
                                  )}
                                </div>
                              </div>
                            </AccordionDetails>
                          ))}
                        </Accordion>
                      );
                    })}
                  </div>
                </>
              )}
              {activeTab === THERMO_TAB && (
                <>
                  {template.thermostatVendor?.id !== '' && (
                    <>
                      <div className='row mb-4'>
                        <div className='col-md-12'>
                          <p className='m-0 template-view-title'>Vendor Name</p>
                          <p className='m-0 template-view-content'>
                            {template.thermostatVendor.name}
                          </p>
                        </div>
                      </div>
                      {[
                        ...template.thermostatVendor.attributes,
                        ...template.thermostatVendor.controlSpecificAttributes,
                      ].filter(({ key, value }, i) => value !== '').length > 0 && (
                        <div className='row mb-4'>
                          <div className='d-flex vendor-card p-3 justify-content-between col-md-6'>
                            <div className='row w-100'>
                              {[
                                ...template.thermostatVendor.attributes,
                                ...template.thermostatVendor.controlSpecificAttributes,
                              ]
                                .filter(({ key, value }, i) => value !== '')
                                .map(({ key, value }, i) => (
                                  <div
                                    className={`col-md-6 mb-3 ${
                                      i > 1 && !expanded ? 'hidden' : ''
                                    } `}
                                    key={i}
                                  >
                                    <TextField
                                      label={key}
                                      id={i + 'vendorAttr'}
                                      className='w-100'
                                      value={value}
                                      InputProps={{
                                        readOnly: true,
                                      }}
                                    />
                                  </div>
                                ))}
                            </div>
                            <div className='vendor-card-arrow '>
                              {expanded ? (
                                <ExpandLess fontSize='large' onClick={() => setExpanded(false)} />
                              ) : (
                                <ExpandMore fontSize='large' onClick={() => setExpanded(true)} />
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                  <div className='row mb-4'>
                    {template.areas.map((area, index) => {
                      return (
                        <Accordion className='mb-0 p-0'>
                          <AccordionSummary className='pl-0' expandIcon={<ExpandMore />}>
                            <p className='m-0 template-view-title'>
                              Room Area Name {index + 1} - {area.name}
                            </p>
                          </AccordionSummary>
                          {area.thermostats.map((item) => (
                            <AccordionDetails>
                              <div className='row vendor-card w-100 p-3'>
                                <div className='col-md-12'>
                                  {/* Add Icon */}
                                  <span color='secondary'>Thermostat Name: </span>
                                  {item.name}
                                </div>
                              </div>
                            </AccordionDetails>
                          ))}
                        </Accordion>
                      );
                    })}
                  </div>
                </>
              )}
              {activeTab === CURTAIN_TAB && (
                <>
                  {template.curtainsVendor?.id !== '' && (
                    <>
                      <div className='row mb-4'>
                        <div className='col-md-12'>
                          <p className='m-0 template-view-title'>Vendor Name</p>
                          <p className='m-0 template-view-content'>
                            {template.curtainsVendor.name}
                          </p>
                        </div>
                      </div>
                      {template.curtainsVendor.attributes.filter(
                        ({ key, value }, i) => value !== '',
                      ).length > 0 && (
                        <div className='row mb-4'>
                          <div className='d-flex vendor-card p-3 justify-content-between col-md-6'>
                            <div className='row w-100'>
                              {template.curtainsVendor.attributes
                                .filter(({ key, value }, i) => value !== '')
                                .map(({ key, value }, i) => (
                                  <div
                                    className={`col-md-6 mb-3 ${
                                      i > 1 && !expanded ? 'hidden' : ''
                                    } `}
                                    key={i}
                                  >
                                    <TextField
                                      label={key}
                                      id={i + 'vendorAttr'}
                                      className='w-100'
                                      value={value}
                                      InputProps={{
                                        readOnly: true,
                                      }}
                                    />
                                  </div>
                                ))}
                            </div>
                            <div className='vendor-card-arrow '>
                              {expanded ? (
                                <ExpandLess fontSize='large' onClick={() => setExpanded(false)} />
                              ) : (
                                <ExpandMore fontSize='large' onClick={() => setExpanded(true)} />
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                  <div className='row mb-4'>
                    {template.areas.map((area, index) => {
                      return (
                        <Accordion className='mb-0 p-0'>
                          <AccordionSummary className='pl-0' expandIcon={<ExpandMore />}>
                            <p className='m-0 template-view-title'>
                              Room Area Name {index + 1} - {area.name}
                            </p>
                          </AccordionSummary>
                          {area?.curtains.map((item) => (
                            <AccordionDetails>
                              <div className='row vendor-card w-100 p-3'>
                                <div className='col-md-3'>
                                  {/* Add Icon */}
                                  <span color='secondary'>Curtain Name: </span>
                                  {item.name}
                                </div>
                                <div className='col-md-3'>
                                  <span color='secondary'>Curtain Type: </span>
                                  {convertEnumToReadable(curtainType, item.type)}
                                </div>
                              </div>
                            </AccordionDetails>
                          ))}
                        </Accordion>
                      );
                    })}
                  </div>
                </>
              )}
              {activeTab === DOOR_LOCK_TAB && (
                <>
                  {template.doorLockVendor?.id !== '' && (
                    <>
                      <div className='row mb-4'>
                        <div className='col-md-12'>
                          <p className='m-0 template-view-title'>Vendor Name</p>
                          <p className='m-0 template-view-content'>
                            {template.doorLockVendor.name}
                          </p>
                        </div>
                      </div>
                      {template.doorLockVendor.attributes.filter(
                        ({ key, value }, i) => value !== '',
                      ).length > 0 && (
                        <div className='row mb-4'>
                          <div className='d-flex vendor-card p-3 justify-content-between col-md-6'>
                            <div className='row w-100'>
                              {template.doorLockVendor.attributes
                                .filter(({ key, value }, i) => value !== '')
                                .map(({ key, value }, i) => (
                                  <div
                                    className={`col-md-6 mb-3 ${
                                      i > 1 && !expanded ? 'hidden' : ''
                                    } `}
                                    key={i}
                                  >
                                    <TextField
                                      label={key}
                                      id={i + 'vendorAttr'}
                                      className='w-100'
                                      value={value}
                                      InputProps={{
                                        readOnly: true,
                                      }}
                                    />
                                  </div>
                                ))}
                            </div>
                            <div className='vendor-card-arrow '>
                              {expanded ? (
                                <ExpandLess fontSize='large' onClick={() => setExpanded(false)} />
                              ) : (
                                <ExpandMore fontSize='large' onClick={() => setExpanded(true)} />
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                  {template?.doorLock?.name && (
                    <div className='row mb-4'>
                      <div className='row vendor-card w-100 p-3'>
                        <div className='col-md-12'>
                          <span color='secondary'>Door Lock Name: </span>
                          {template.doorLock.name}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GuestRoomExperienceTemplateView;
